/* eslint-disable indent */
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
// components
import Header from "components/Header";
import Footer from "../Footer/Footer";
import GameTypeNav from "../common/GameTypeNav";
import GameTileBox from "../common/GameTileBox";
import GameNavMobile from "../common/GameNavMobile";
import BeforeAnimation from "../common/BeforeAnimation";
// external css
import "./Home.css";
// images
import { ReactComponent as TrunkHoles } from "icons/trunk_holes.svg";
import Screen1Left from "icons/home_screen1_left.png";
import Screen1Right from "icons/home_screen1_right.png";
import Screen1LeftSm from "icons/home_screen1_left_sm.png";
import Screen1RightSm from "icons/home_screen1_right_sm.png";
import Screen1LeftXs from "icons/home_screen1_left_xs.png";
import Screen1RightXs from "icons/home_screen1_right_xs.png";
import DoorOverlay from "icons/door_overlay.png";
import PineTree from "icons/home_pine_tree.png";
import Projector from "icons/projector.png";
import ProjectorOn from "icons/projector_on.png";
import ProjectorBg from "icons/projector_bg.png";
import Fiks from "icons/fiks_idle.gif";
import NetaIdle from "icons/neta_idle.gif";
import MoyoIdle from "icons/moyo_idle.gif";
import FiksRemote from "icons/fiks_remote.gif";
import LeftHut from "icons/home_left_hut.png";
import SmokeCloud from "icons/smoke_cloud.png";
import Music from "icons/music.png";
import MusicPlaying from "icons/music-playing.png";
import MayoClimb from "icons/mayo_climb.png";
import MayoClimbHands from "icons/mayo_climb_hands.png";
import NetaClimb from "icons/neta_climb.png";
import NetaClimbHands from "icons/neta_climb_hands.png";
import TrunkDoor from "icons/trunk_door.png";
import MidPlatform from "icons/mid_platform.png";
import MidRightHut from "icons/mid_right_hut.png";
// gifs
import NetaHi from "icons/neta_hi.gif";
// music
import backgroundMusic from "assets/Background_Music.mp3";
import smokeMusic from "assets/Chimney_smoke.wav";
import remoteMusic from "assets/Fiks_remote.wav";
import stepsMusic from "assets/Steps.mp3";
import slideMusic from "assets/Pole_slide.wav";
import waveMusic from "assets/neta_wave.wav";
// constants
import { gameTypesList } from "constant";
import { appPath } from "services/Constants";
// gsap
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//apiHandler
import { getData } from "services/ApiHandler";
import { getUser } from "services/Constants";

/* value proposition modal*/
import logo from "icons/auth/logo.png";
import moyoWellDone from "icons/Owl_Well_Done.png";
import premiumBadge from "icons/premium-badge.png";

import Modal from "components/common/Modal";

export function Home() {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isBgMusicPlaying, setMusicPlaying] = useState(false);
  const [showMoreGames, setMoreGames] = useState(false);
  const [showTopNeta, setTopNeta] = useState(false);
  const [showMidNeta, setMidNeta] = useState(false);
  const [showMidMayo, setMidMayo] = useState(true);
  const [showClimbNeta, setClimbNeta] = useState(false);
  const [showClimbMayo, setClimbMayo] = useState(false);
  const [showNetaWave, setNetaWave] = useState(true);
  const [isReverse, setReverse] = useState(false);
  const [isMidReverse, setMidReverse] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [initialize, setInitialize] = useState(false);
  const [gameType, setGameType] = useState("Free Games");

  const [searchParams, setSearchParams] = useSearchParams();

  /*subscription status*/
  const [isSubscribed, setIsSubscibed] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  /* show valueproposition modal*/
  const [showModal, setShowModal] = useState(false);

  const [showFiksRemote, setFiksRemote] = useState(false);
  const [isProjectorVisible, setProjectorVisible] = useState(false);

  const [viewWidth, setViewWidth] = useState(0);

  const navRef = useRef();
  const navRefBottomFixed = useRef();
  const tileBoxRef = useRef();
  const container = useRef();
  const tl = useRef();
  gsap.registerPlugin(ScrollTrigger);
  const location = useLocation();

  const getAPiData = getData;

  const valuePropositionModal = (setStatus) => {
    setShowModal(setStatus);
  };
  const validateUser = async () => {
    let auth_token = localStorage.getItem("token");
    if (auth_token) {
      let response = await getAPiData(getUser, auth_token);
      setIsSubscibed(response?.isSubscribed);
      setUserEmail(response?.Email);
    }
  };
  useEffect(() => {
    if (location?.state?.from === "game" || location?.state?.from === "video") {
      setShowLoader(true);
      forceUpdate();
      setTimeout(() => {
        setInitialize(true);
      }, 1000);
    } else {
      setInitialize(true);
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setViewWidth(window.innerWidth);
    const waveMusic = document.getElementById("waveAudio");
    if (showNetaWave && isBgMusicPlaying && window.innerWidth > 600) {
      waveMusic.play();
    } else {
      waveMusic.pause();
    }
  }, [showNetaWave]);

  useEffect(() => {
    window.addEventListener(
      "orientationchange",
      function () {
        window.location.reload();
      },
      false
    );
  }, []);
  useEffect(() => {
    if (!dataLoaded) {
      validateUser();
      setDataLoaded(true);
    }
  }, []);
  const playBgMusic = () => {
    const bgMusic = document.getElementById("bgAudio");
    bgMusic.volume = 0.2;
    bgMusic.play();
    bgMusic.loop = true;
    setMusicPlaying(true);
  };

  const pauseBgMusic = () => {
    const bgMusic = document.getElementById("bgAudio");
    bgMusic.pause();
    setMusicPlaying(false);
  };

  //create your forceUpdate hook
  function useForceUpdate() {
    // eslint-disable-next-line no-unused-vars
    const [value, setValue] = useState(0); // integer state
    return () => setValue((value) => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here
    // is better than directly setting `setValue(value + 1)`
  }

  const forceUpdate = useForceUpdate();

  const scrollToSection = (type) => {
    switch (type) {
      // eslint-disable-next-line indent
      case "Free Games":
        window.scrollTo({
          top: document.getElementById("freeGameRef").offsetTop,
          behavior: "smooth",
        });
        break;
      case "Premium Games":
        window.scrollTo({
          top: document.getElementById("premiumGameRef").offsetTop,
          behavior: "smooth",
        });
        break;
      case "Videos":
        window.scrollTo({
          top: document.getElementById("videosRef").offsetTop,
          behavior: "smooth",
        });
        break;
    }
  };

  useLayoutEffect(() => {
    setFiksRemote(false);
    setTimeout(() => {
      setShowLoader(false);
    }, 2000);
    const ctx = gsap.context((self) => {
      // left and right transition effect
      tl.current = gsap.from(self.selector(".home_left_tree_container"), {
        duration: 1,
        left: "-50%",
      });
      tl.current = gsap.from(self.selector(".home_right_tree"), {
        duration: 1,
        right: "-50%",
      });
      tl.current = gsap.fromTo(
        self.selector(".gtc_background, .nav_item_bg"),
        {
          duration: 1,
          width: "30%",
          opacity: 0.4,
        },
        {
          duration: 1,
          width: "100%",
          opacity: 1,
        }
      );
      tl.current = gsap.fromTo(
        ".game_title_name , .gtc_content, .mobile_nav",
        {
          opacity: "0",
        },
        {
          opacity: "1",
        }
      );
      // background parallax effects
      tl.current = gsap.to(".home_pine_tree", {
        scrollTrigger: {
          scrub: true,
        },
        y: (i, target) =>
          -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
      tl.current = gsap.to(".purple_lite_bg", {
        scrollTrigger: {
          scrub: true,
        },
        y: (i, target) =>
          -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
      tl.current = gsap.to(".purple_bg", {
        scrollTrigger: {
          scrub: true,
        },
        y: (i, target) =>
          -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
      tl.current = gsap.to(".green_bg", {
        scrollTrigger: {
          scrub: true,
        },
        y: (i, target) =>
          -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
      tl.current = gsap.to(".green_flower_bg", {
        scrollTrigger: {
          scrub: true,
        },
        y: (i, target) =>
          -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
      // smoke animation
      let smokeTl = gsap.timeline({ repeat: -1, repeatDelay: 0 });
      const smokeSound = document.getElementById("smokeAudio");
      tl.current = smokeTl
        .fromTo(
          ".rh_sc_1",
          {
            opacity: 1,
          },
          {
            duration: 4,
            y: -999,
            scale: 5,
            opacity: 0,
            onStart: function () {
              if (isBgMusicPlaying && window.innerWidth > 600) {
                smokeSound.play();
              }
            },
          },
          1
        )
        .fromTo(
          ".rh_sc_2",
          {
            opacity: 1,
          },
          {
            duration: 5,
            y: -999,
            scale: 5,
            opacity: 0,
            onStart: function () {
              if (isBgMusicPlaying && window.innerWidth > 600) {
                smokeSound.play();
              }
            },
          },
          2
        )
        .fromTo(
          ".rh_sc_3",
          {
            opacity: 1,
          },
          {
            duration: 6,
            y: -999,
            scale: 5,
            opacity: 0,
            onStart: function () {
              if (isBgMusicPlaying && window.innerWidth > 600) {
                smokeSound.play();
              }
            },
          },
          3
        );
      // neta moving left
      let frame_count = 6,
        offset_value = 58;
      const stepsSound = document.getElementById("stepsAudio");
      gsap.to(".neta_move_left", {
        x: "-200px",
        backgroundPosition: -offset_value * frame_count * 2 + "px 0%",
        ease: "steps(" + frame_count + ")", // use a stepped ease for the sprite sheet
        scrollTrigger: {
          trigger: ".screen1_bg",
          start: "top top",
          end: "+=" + frame_count * offset_value,
          scrub: true,
          onEnter: function () {
            setTopNeta(true);
            setReverse(false);
            if (isBgMusicPlaying && window.innerWidth > 600) {
              stepsSound.play();
            }
          },
          onLeave: function () {
            setTopNeta(false);
            setNetaWave(false);
          },
          onEnterBack: function () {
            setTopNeta(true);
            setNetaWave(true);
            setReverse(true);
            setProjectorVisible(false);
            if (isBgMusicPlaying && window.innerWidth > 600) {
              stepsSound.play();
            }
          },
          onLeaveBack: function () {
            setTopNeta(false);
          },
        },
      });

      // neta move right
      let frame_count_1 = 4,
        offset_value_1 = 57.6;
      const netaMoveRightNum = window.innerWidth <= 820 ? 45 : 5;
      const netMoveRightSpace = window.innerWidth <= 820 ? "60%" : "700%";
      gsap.to(".neta_move_right", {
        x: netMoveRightSpace,
        backgroundPosition: -offset_value_1 * frame_count_1 * 2 + "px 0%",
        ease: "steps(" + frame_count_1 + ")", // use a stepped ease for the sprite sheet
        scrollTrigger: {
          trigger: ".home_screen2",
          start: `top ${netaMoveRightNum}%`,
          end: "+=" + frame_count_1 * offset_value_1,
          scrub: true,
          onEnter: function () {
            setMidNeta(true);
            setClimbNeta(false);
            setMidReverse(false);
            if (isBgMusicPlaying && window.innerWidth > 600) {
              stepsSound.play();
            }
          },
          onLeave: function () {
            setMidNeta(false);
            setClimbNeta(true);
          },
          onEnterBack: function () {
            setMidNeta(true);
            setClimbNeta(false);
            setMidReverse(true);
            setProjectorVisible(false);
            if (isBgMusicPlaying && window.innerWidth > 600) {
              stepsSound.play();
            }
          },
          onLeaveBack: function () {
            setMidNeta(false);
            // setClimbNeta(true);
          },
        },
      });

      // mayo move left
      let frame_count_2 = 2,
        offset_value_2 = 78;
      gsap.to(".mayo_move_left", {
        x: "-100%",
        backgroundPosition: -offset_value_2 * frame_count_2 * 2 + "px 0%",
        ease: "steps(" + frame_count_2 + ")", // use a stepped ease for the sprite sheet
        scrollTrigger: {
          trigger: ".home_screen2",
          start: `top ${netaMoveRightNum}%`,
          end: "+=" + frame_count_2 * offset_value_2,
          scrub: true,
          onEnter: function () {
            setMidMayo(true);
            setClimbMayo(false);
            setMidReverse(false);
          },
          onLeave: function () {
            setMidMayo(false);
            setClimbMayo(true);
          },
          onEnterBack: function () {
            setMidMayo(true);
            setClimbMayo(false);
            setMidReverse(true);
            setProjectorVisible(false);
          },
          onLeaveBack: function () {
            setMidMayo(true);
            // setClimbMayo(true);
          },
        },
      });

      // neta climb down
      const slideSound = document.getElementById("slideAudio");
      const topClimbdown = viewWidth <= 820 ? 90 : 65;
      gsap.to(".mayo_climb_container, .neta_climb_container", {
        yPercent: 1300,
        ease: "none",
        scrollTrigger: {
          trigger: ".home_screen3",
          start: `top ${topClimbdown}%`,
          end: "bottom",
          scrub: true,
          onEnter: function () {
            if (isBgMusicPlaying && window.innerWidth > 600) {
              slideSound.play();
            }
          },
          onEnterBack: function () {
            if (isBgMusicPlaying && window.innerWidth > 600) {
              slideSound.play();
            }
            setProjectorVisible(false);
          },
        },
      });

      // fik projector animation
      const remoteAnimPosStart = viewWidth <= 600 ? 40 : 10;
      const remoteSound = document.getElementById("remoteAudio");
      gsap.to(".fik_projector_on", {
        stagger: 2,
        delay: 2,
        scrollTrigger: {
          trigger: ".home_screen4",
          start: `top ${remoteAnimPosStart}%`,
          scrub: true,
          onEnter: function () {
            setFiksRemote(true);
            if (isBgMusicPlaying) {
              remoteSound.play();
            }
            setTimeout(() => {
              setProjectorVisible(true);
              setFiksRemote(false);
            }, 500);
          },
          onLeaveBack: function () {
            setProjectorVisible(false);
          },
        },
      });

      const onScrollContainerAnimation = () => {
        tl.current = gsap.from(self.selector(".home_right_tree"), {
          duration: 1,
          right: "-50%",
        });
        tl.current = gsap.fromTo(
          self.selector(".gtc_background, .nav_item_bg"),
          {
            duration: 1,
            width: "30%",
            opacity: 0.4,
          },
          {
            duration: 1,
            width: "100%",
            opacity: 1,
          }
        );
        tl.current = gsap.fromTo(
          self.selector(".game_tile_box"),
          {
            duration: 1,
            y: 90,
            opacity: 0.5,
          },
          {
            duration: 1,
            y: 0,
            opacity: 1,
          }
        );
      };

      // on scroll game section animation
      // 1. collapse show more
      gsap.fromTo(
        ".game_tile_box, .mobile_nav",
        {
          opacity: "1",
          scrollTrigger: {
            trigger: ".gtc_content",
            start: "top top",
            scrub: "true",
            onEnter: function () {
              // navRef.current.setType(event, -1);
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onEnterBack: function (event) {
              if (navRef?.current?.getType() !== 0)
                onScrollContainerAnimation();
              navRef?.current?.setType(event, 0);
              setGameType("Free Games");
              // onScrollContainerAnimation();
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
          },
        },
        {
          opacity: "1",
          scrollTrigger: {
            trigger: ".gtc_content",
            start: "top top",
            scrub: "true",
          },
        }
      );
      // 2. select premium game
      const premiumScrollPosStart = viewWidth <= 820 ? 40 : 5;
      gsap.fromTo(
        ".game_tile_box, .mobile_nav",
        {
          scrollTrigger: {
            trigger: ".home_screen2",
            start: `top ${premiumScrollPosStart}%`,
            end: "top -10%",
            once: false,
            scrub: true,
            onEnter: function (event) {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
              if (navRef?.current?.getType() !== 1)
                onScrollContainerAnimation();
              navRef?.current?.setType(event, 1);
              setGameType("Premium Games");
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onEnterBack: function (event) {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
              if (navRef?.current?.getType() !== 1)
                onScrollContainerAnimation();
              navRef?.current?.setType(event, 1);
              setGameType("Premium Games");
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onLeave: function () {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onLeaveBack: function () {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
          },
        },
        {
          scrollTrigger: {
            trigger: ".home_screen2",
            start: "top 5%",
            end: "top -10%",
            once: false,
            scrub: true,
          },
        }
      );
      // adjust position of game container
      gsap.to(".fixed-game-box", {
        top: "2%",
        scrollTrigger: {
          trigger: ".fixed-game-box",
          start: "top 5%",
          end: "top 0%",
          scrub: "true",
          onEnter: function () {
            setMoreGames(false);
            tileBoxRef.current?.handleShowMore();
          },
        },
      });
      // 3. collpase show more if open
      gsap.fromTo(
        ".gtc_background, .nav_item_bg",
        {
          width: "100%",
          scrollTrigger: {
            trigger: ".home_screen2",
            start: "top -5%",
            end: "top -10%",
            scrub: "true",
            onEnter: function () {
              // navRef.current.setType(event, -1);
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onEnterBack: function (event) {
              navRef?.current?.setType(event, 1);
              setGameType("Premium Games");
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onLeave: function () {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
            onLeaveBack: function () {
              setMoreGames(false);
              tileBoxRef.current?.handleShowMore();
            },
          },
        },
        {
          width: "100%",
          scrollTrigger: {
            trigger: ".home_screen2",
            start: "top -5%",
            end: "top -10%",
            scrub: "true",
          },
        }
      );
      // 4. trigger selection
      const videosScrollPosStart =
        viewWidth <= 820 ? (window.innerWidth <= 600 ? 40 : 10) : 25;
      gsap.fromTo(
        ".game_tile_box, .mobile_nav",
        {
          opacity: "1",
          scrollTrigger: {
            trigger: ".home_screen4",
            start: `top ${videosScrollPosStart}%`,
            end: "top 22%",
            scrub: "true",
            onEnter: function (event) {
              if (navRef?.current?.getType() !== 2)
                onScrollContainerAnimation();
              navRef?.current?.setType(event, 2);
              navRefBottomFixed.current?.setType(event, 2);
              setGameType("Videos");
            },
            onEnterBack: function () {
              // navRef.current.setType(event, -1);
              // navRefBottomFixed.current.setType(event, -1);
            },
          },
        },
        {
          opacity: "1",
          scrollTrigger: {
            trigger: ".home_screen4",
            start: "top 25%",
            end: "top 22%",
            scrub: "true",
          },
        }
      );

      // trunk lift animation
      const trunkScrollPosStart = viewWidth <= 820 ? 70 : 90;
      for (let i = 0; i < 10; i++) {
        gsap.fromTo(
          `#tree_trunk_${i + 1}`,
          {
            fill: "#351004",
            opacity: "1",
          },
          {
            fill: "#FDD12A",
            opacity: "1",
            scrollTrigger: {
              trigger: `#tree_trunk_${i + 1}`,
              start: `top ${trunkScrollPosStart}%`,
              end: "+=99",
              scrub: "true",
              onLeave: function () {
                gsap.to(`#tree_trunk_${i + 1}`, {
                  fill: "#351004",
                });
              },
            },
          }
        );
      }
    }, container); // <- Scope!
    return () => ctx.revert(); // <- Cleanup!
  }, [isBgMusicPlaying]);

  useEffect(() => {
    window.addEventListener("scroll", scrollDetector);

    return () => window.removeEventListener("scroll", scrollDetector);
  }, []);

  const navMobileCatHandle = (selectedType) => {
    setGameType(selectedType);
  };

  const scrollDetector = () => {
    if (window.scrollY < 300) {
      setProjectorVisible(false);
    }
  };
  return (
    <>
      {showLoader && <BeforeAnimation />}
      {!isBgMusicPlaying && (
        <img
          src={Music}
          className="home_play_music"
          onClick={playBgMusic}
          alt="play music"
        />
      )}
      {isBgMusicPlaying && (
        <img
          src={MusicPlaying}
          className="home_play_music"
          onClick={pauseBgMusic}
          alt="pause music"
        />
      )}
      <div
        ref={container}
        style={{
          overflow: "hidden",
          visibility: initialize ? "visible" : "hidden",
        }}
      >
        <audio id="bgAudio" loop className="hidden">
          <source src={backgroundMusic} type="audio/mpeg" />
        </audio>
        <audio id="smokeAudio" className="hidden">
          <source src={smokeMusic} type="audio/mpeg" />
        </audio>
        <audio id="remoteAudio" className="hidden">
          <source src={remoteMusic} type="audio/mpeg" />
        </audio>
        <audio id="stepsAudio" className="hidden">
          <source src={stepsMusic} type="audio/mpeg" />
        </audio>
        <audio id="slideAudio" className="hidden">
          <source src={slideMusic} type="audio/mpeg" />
        </audio>
        <audio id="waveAudio" className="hidden">
          <source src={waveMusic} type="audio/mpeg" />
        </audio>

        <div className="screen1_bg" id="freeGameRef">
          <div className="bg_clouds">
            <Header isSubscribed={isSubscribed} userEmail={userEmail} />

            {/* left tree container */}
            <div className="home_left_tree_container">
              <div className="left_tree_flex">
                <img
                  src={Screen1Left}
                  alt="left tree"
                  className="hltc_tree hidden-sm"
                />
                <img
                  src={Screen1LeftSm}
                  className="hltc_tree visible-sm"
                  alt="left tree"
                />
                <img
                  src={DoorOverlay}
                  alt="door overlay"
                  className="left_door_overlay"
                />
                {!showTopNeta && showNetaWave && (
                  <img src={NetaHi} className="neta_waving" alt="Neta Waving" />
                )}

                <div className="neta_run_left">
                  <div
                    className={`neta_move_left ${
                      showTopNeta ? "opacity_one" : "opacity_zero"
                    } ${isReverse ? "neta_move_left_reverse" : ""}`}
                  ></div>
                </div>

                <TrunkHoles className="tree_trunk_holes" />
                <img src={TrunkDoor} className="tree_trunk_door" />
              </div>
            </div>

            {/* right tree container */}
            <div className="home_right_tree_container">
              <div className="right_tree_flex">
                <img
                  src={Screen1Right}
                  className="hltc_tree hidden-sm"
                  alt="right tree"
                />
                <img
                  src={Screen1RightSm}
                  className="hltc_tree visible-sm"
                  alt="right tree"
                />

                {/* mid platform and hut */}
                <img src={MidPlatform} className="mid_platform" />
                <img src={MidRightHut} className="mid_right_hut" />

                {/* smoke clouds */}
                <img
                  src={SmokeCloud}
                  alt="smoke cloud"
                  className="smoke_cloud rh_sc_1"
                />
                <img
                  src={SmokeCloud}
                  alt="smoke cloud"
                  className="smoke_cloud rh_sc_2"
                />
                <img
                  src={SmokeCloud}
                  alt="smoke cloud"
                  className="smoke_cloud rh_sc_3"
                />

                {/* Neta and Mayo move on mid platform */}
                <div
                  className={`neta_move_right ${
                    showMidNeta ? "opacity_one" : "opacity_zero"
                  } ${isMidReverse ? "neta_move_right_reverse" : ""}`}
                ></div>

                <div
                  className={`mayo_move_left ${
                    showMidMayo ? "opacity_one" : "opacity_zero"
                  }  ${isMidReverse ? "mayo_move_left_reverse" : ""}`}
                ></div>

                {/* climb down container */}
                <div className="climb_container climb_container_right">
                  <div className="relative">
                    <div className="climb_bamboo">&nbsp;</div>
                    <div
                      className={`mayo_climb_container ${
                        showClimbMayo ? "" : "not-visible"
                      }`}
                    >
                      <div className="relative">
                        <img
                          src={MayoClimb}
                          alt="mayo climb"
                          className="mayo_climb"
                        />
                        <img
                          src={MayoClimbHands}
                          alt="mayo climb hands"
                          className="mayo_climb_hands"
                        />
                        <div className="mayo_climb_bamboo">&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="climb_container climb_container_left">
                  <div className="relative">
                    <div className="climb_bamboo">&nbsp;</div>
                    <div
                      className={`neta_climb_container ${
                        showClimbNeta ? "" : "not-visible"
                      }`}
                    >
                      <img
                        src={NetaClimb}
                        alt="neta climb"
                        className="neta_climb"
                      />
                      <img
                        src={NetaClimbHands}
                        alt="neta climb hands"
                        className="neta_climb_hands"
                      />
                      <div className="neta_climb_bamboo">&nbsp;</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <img
              src={Screen1LeftXs}
              className="home_left_tree visible-xs"
              alt="left tree"
            />
            <img
              src={Screen1RightXs}
              className="home_right_tree visible-xs"
              alt="right tree"
            />

            <div
              className={`container ${
                searchParams.get("gameId") ? " " : "fixed-game-box"
              }`}
              style={{
                visibility:
                  isProjectorVisible || !initialize ? "hidden" : "visible",
                opacity: isProjectorVisible || !initialize ? 0 : 1,
              }}
            >
              <div className="row">
                <div className="col-md-1 hiddens-m hidden-xs">&nbsp;</div>
                <div className="col-sm-12 col-md-12 col-lg-10 detail_content_aligner">
                  <div className="game_title_container">
                    <div className="gtc_background">&nbsp;</div>

                    <span className="game_title_name">
                      Let&apos;s Start Playing
                    </span>

                    <div className="gtc_content">
                      Tired of downloading a new game each time? Now Play Online
                      without any login or hassle with SKIDOS! Action,
                      Adventure, Racing, Drama- scroll down to choose a game and
                      <br />
                      <strong>Just start playing!</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
              </div>

              <div className="visible-xs visible-sm detail_content_aligner mobile_nav">
                <GameNavMobile
                  type={gameType}
                  navMobileCatHandle={navMobileCatHandle}
                  typeList={["Free Games", "Premium Games", "Videos"]}
                />
              </div>

              <div className="row topgap30 topgap-xs-0 topgap-sm-0">
                <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
                <div className="col-sm-12 col-md-12 col-lg-10 detail_content_aligner overlap_zindex">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-4 hidden-sm hidden-xs">
                      <GameTypeNav
                        showMoreGames={showMoreGames}
                        list={gameTypesList}
                        ref={navRef}
                        scrollFn={scrollToSection}
                      />
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-8">
                      <GameTileBox
                        ref={tileBoxRef}
                        setMoreGames={setMoreGames}
                        listType={gameType}
                        isSubscribed={isSubscribed}
                        valuePropositionModal={valuePropositionModal}
                        userEmail={userEmail}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
              </div>
            </div>

            <div className="home_whitespace">&nbsp;</div>
          </div>
        </div>

        <div className="home_screen2" id="premiumGameRef">
          <img src={PineTree} className="home_pine_tree" data-speed=".25" />
          <div className="purple_lite_bg" data-speed=".55"></div>
        </div>

        <div className="home_screen3">
          <div className="purple_bg" data-speed=".40"></div>
        </div>

        <div className="home_screen4" id="videosRef">
          <div className="green_bg" data-speed=".25"></div>
        </div>

        <div className="home_screen5">
          <div className="green_lite_bg" data-speed=".15"></div>
          <img src={LeftHut} className="home_left_hut" alt="hut" />

          <div
            className="container bottom-game-container"
            style={{
              visibility: isProjectorVisible ? "visible" : "hidden",
              opacity: isProjectorVisible ? 1 : 0,
            }}
          >
            <div className="row">
              <div className="col-md-1 hiddens-m hidden-xs">&nbsp;</div>
              <div className="col-sm-12 col-md-12 col-lg-10 detail_content_aligner">
                <div className="game_title_container">
                  <div className="gtc_background">&nbsp;</div>

                  <span className="game_title_name">
                    Let&apos;s Start Playing
                  </span>

                  <div className="gtc_content">
                    Tired of downloading a new game each time? Now Play Online
                    without any login or hassle with SKIDOS! Action, Adventure,
                    Racing, Drama- scroll down to choose a game and
                    <br />
                    <strong>Just start playing!</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
            </div>

            <div className="visible-xs visible-sm detail_content_aligner mobile_nav">
              <GameNavMobile
                type={gameType}
                typeList={["Free Games", "Premium Games", "Videos"]}
              />
            </div>

            <div className="row topgap30 topgap-xs-0 topgap-sm-0">
              <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
              <div className="col-sm-12 col-md-12 col-lg-10 detail_content_aligner overlap_zindex">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-4 hidden-sm hidden-xs">
                    <GameTypeNav
                      showMoreGames={showMoreGames}
                      list={gameTypesList}
                      ref={navRefBottomFixed}
                      scrollFn={scrollToSection}
                    />
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-8">
                    <GameTileBox
                      setMoreGames={setMoreGames}
                      listType={gameType}
                      isSubscribed={isSubscribed}
                      valuePropositionModal={valuePropositionModal}
                      userEmail={userEmail}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-1 hidden-xs hidden-sm">&nbsp;</div>
            </div>
          </div>

          <div className="home_projector">
            <div className="relative">
              {showFiksRemote ? (
                <img
                  src={FiksRemote}
                  alt="fiks"
                  className="rightgap20 bottom_fiks_remote"
                />
              ) : (
                <img
                  src={Fiks}
                  alt="fiks"
                  // height="70"
                  className="rightgap20 bottom_fiks"
                />
              )}
              <img
                src={Projector}
                alt="projector"
                className="leftgap20 rightgap20 bottom_projector"
              />
              <img
                src={ProjectorOn}
                alt="projector"
                className="fik_projector_on"
                style={{
                  visibility: isProjectorVisible ? "visible" : "hidden",
                }}
              />
              <img
                src={ProjectorBg}
                alt="projector bg"
                className="fik_projector_bg"
                style={{
                  visibility: isProjectorVisible ? "visible" : "hidden",
                }}
              />
              <img
                src={NetaIdle}
                alt="fiks"
                width="70"
                className="leftgap20 rightgap20 bottom_neta"
              />
              <img
                src={MoyoIdle}
                alt="fiks"
                width="120"
                className="rightgap20 bottom_moyo"
              />
            </div>
          </div>
        </div>

        <div className="home_screen6">
          <div className="green_flower_bg" data-speed=".10"></div>
        </div>
        <Footer />
      </div>
      <Modal show={showModal} className="value-proposition">
        <span className="close-btn" onClick={() => setShowModal(false)}></span>
        <div className="container">
          <div className="row">
            <div className="col-sm-7">
              <ul>
                <img src={logo} className="skidos-logo" />
                <li>
                  <span></span>Unlimited play, no downloads.
                </li>
                <li>
                  <span></span> Child-friendly and safe games.
                </li>
                <li>
                  <span></span> Play on Mobile, Tablet or Desktop.
                </li>
                <li>
                  <span></span> Games for all ages and interests.
                </li>
                <li>
                  <span></span> Trusted by 4 million parents
                </li>
              </ul>
              <img src={moyoWellDone} className="moyo-well-done" />
            </div>
            <div className="col-sm-5 premium-section">
              <div className="premium-pass mt-4">
                <img src={premiumBadge} />
                <span>Premium</span> Pass
              </div>
              <h3 className="mt-3">Unlock this and more games & videos</h3>
              <button
                className="btn btn-warning premium-btn mt-4"
                onClick={() =>
                  window.location.replace(appPath + "acquisition_instant_game")
                }
              >
                Activate Premium
              </button>
              {!userEmail && (
                <>
                  <p className="mt-4 login-action">
                    Already a member?{" "}
                    <span
                      onClick={() =>
                        window.location.replace(appPath + "ig_login")
                      }
                    >
                      Log in to play
                    </span>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Home;
